import { render, staticRenderFns } from "./applicationAuthorMobile.vue?vue&type=template&id=66952e76&scoped=true&"
import script from "./applicationAuthorMobile.vue?vue&type=script&lang=js&"
export * from "./applicationAuthorMobile.vue?vue&type=script&lang=js&"
import style0 from "./applicationAuthorMobile.vue?vue&type=style&index=0&id=66952e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66952e76",
  null
  
)

export default component.exports